import React from 'react';
import { stackingOrder } from '@alfa-bank/site-stack';
import type { FC } from 'react';

import type { TSidePanelDesktop } from '../models';

export const SidePanelDesktop: FC<TSidePanelDesktop> = ({
    SidePanel,
    Stack,
    children,
    className,
    dataTestId,
    onClose,
    open = false,
}) => {
    return (
        <Stack value={stackingOrder.OVERLAY}>
            {zIndex => (
                <SidePanel
                    className={className}
                    dataTestId={dataTestId}
                    onClose={onClose}
                    open={open}
                    zIndex={zIndex}
                >
                    {children}
                </SidePanel>
            )}
        </Stack>
    );
};
